import React, { useEffect, useState } from 'react';
import { useNewOrderContext } from '../../../context/NewOrderContext';
import FoodSuggestItem from './FoodSuggestItem';
import { FoodDetailItem } from '../../../interfaces/types';
import { useUserMenuContext } from '../../../context/UserMenuContext';
import { useSystemContext } from '../../../context/SystemContext/SystemContext';
import { isPreOrderDisabled } from '../../../utils/preOrderDisabled';
import { fetchGameDayData, GameDayData } from '../../../utils/timeSlots';

interface ConveyorBeltNewProps {
  suggestedFoods: FoodDetailItem[];
  activeCategoryId: string;
  onFoodClick?: (food: FoodDetailItem, categoryId: string) => void;
}

const ConveyorBeltNew: React.FC<ConveyorBeltNewProps> = ({ suggestedFoods, activeCategoryId, onFoodClick }) => {
  const { orderDetails } = useNewOrderContext();
  const { listRestaurantData } = useUserMenuContext();
  const { seatInfo, stadiumInfo, isPreOrder } = useSystemContext();
  const [gameDayData, setGameDayData] = useState<GameDayData | null>(null);

  useEffect(() => {
    const loadGameDayData = async () => {
      if (!stadiumInfo?.id || !seatInfo?.order_date) {
        setGameDayData(null);
        return;
      }

      const data = await fetchGameDayData(stadiumInfo.id, seatInfo.order_date);
      setGameDayData(data);
    };

    loadGameDayData();
  }, [seatInfo?.order_date, stadiumInfo?.id]);

  const handleFoodClick = (food: FoodDetailItem) => {
    if (!onFoodClick) return;
    onFoodClick(food, activeCategoryId);
  };

  return (
    <div className="flex overflow-x-auto no-scrollbar">
      {suggestedFoods.map((food) => {
        const restaurant = listRestaurantData?.find((r) => r.id === food.restaurantId);
        const preOrderStatus = isPreOrderDisabled(food, restaurant, seatInfo?.order_date, isPreOrder ?? false, orderDetails.delivery_request, gameDayData);
        const isDisabled = preOrderStatus?.disabled === true;

        return (
          <div
            key={food.id}
            onClick={() => {
              if (isDisabled) return;
              handleFoodClick(food);
            }}
            className={`cursor-pointer ${isDisabled ? 'opacity-50 pointer-events-none' : ''}`}
          >
            <FoodSuggestItem name={food.name} image={food.image_url} price={food.price} preOrderStatus={preOrderStatus} />
          </div>
        );
      })}
    </div>
  );
};

export default ConveyorBeltNew;
